 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLCH000_FM01_HALF from '@/components/xhtml/ch000_fm01_half'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCH000_FM02_TITLE from '@/components/xhtml/ch000_fm02_title'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLCH000_FM03_INTRO from '@/components/xhtml/ch000_fm03_intro'
 import XHTMLCH000_FM04_PRE from '@/components/xhtml/ch000_fm04_pre'
 import XHTMLCH001 from '@/components/xhtml/ch001'
 import XHTMLCH002 from '@/components/xhtml/ch002'
 import XHTMLCH003 from '@/components/xhtml/ch003'
 import XHTMLCH004 from '@/components/xhtml/ch004'
 import XHTMLCH005 from '@/components/xhtml/ch005'
 import XHTMLCH006 from '@/components/xhtml/ch006'
 import XHTMLCH007 from '@/components/xhtml/ch007'
 import XHTMLCH008 from '@/components/xhtml/ch008'
 import XHTMLCH009 from '@/components/xhtml/ch009'
 import XHTMLCH010 from '@/components/xhtml/ch010'
 import XHTMLCH011 from '@/components/xhtml/ch011'
 import XHTMLCH012 from '@/components/xhtml/ch012'
 import XHTMLCH013 from '@/components/xhtml/ch013'
 import XHTMLCH014 from '@/components/xhtml/ch014'
 import XHTMLCH015 from '@/components/xhtml/ch015'
 import XHTMLCH016 from '@/components/xhtml/ch016'
 import XHTMLCH017 from '@/components/xhtml/ch017'
 import XHTMLCH018 from '@/components/xhtml/ch018'
 import XHTMLCH019 from '@/components/xhtml/ch019'
 import XHTMLCH020 from '@/components/xhtml/ch020'
 import XHTMLCH021 from '@/components/xhtml/ch021'
 import XHTMLCH022 from '@/components/xhtml/ch022'
 import XHTMLCH023 from '@/components/xhtml/ch023'
 import XHTMLCH024 from '@/components/xhtml/ch024'
 import XHTMLCH025 from '@/components/xhtml/ch025'
 import XHTMLCH026 from '@/components/xhtml/ch026'
 import XHTMLCH027 from '@/components/xhtml/ch027'
 import XHTMLCH028 from '@/components/xhtml/ch028'
 import XHTMLCH029 from '@/components/xhtml/ch029'
 import XHTMLCH030 from '@/components/xhtml/ch030'
 import XHTMLCH031 from '@/components/xhtml/ch031'
 import XHTMLCH032 from '@/components/xhtml/ch032'
 import XHTMLCH033 from '@/components/xhtml/ch033'
 import XHTMLCH034 from '@/components/xhtml/ch034'
 import XHTMLCH035 from '@/components/xhtml/ch035'
 import XHTMLCH036 from '@/components/xhtml/ch036'
 import XHTMLCH037 from '@/components/xhtml/ch037'
 import XHTMLCH038 from '@/components/xhtml/ch038'
 import XHTMLCH039 from '@/components/xhtml/ch039'
 import XHTMLCH040 from '@/components/xhtml/ch040'
 import XHTMLCH041 from '@/components/xhtml/ch041'
 import XHTMLCH042 from '@/components/xhtml/ch042'
 import XHTMLCH043 from '@/components/xhtml/ch043'
 import XHTMLCH044 from '@/components/xhtml/ch044'
 import XHTMLCH045 from '@/components/xhtml/ch045'
 import XHTMLCH046 from '@/components/xhtml/ch046'
 import XHTMLCH047 from '@/components/xhtml/ch047'
 import XHTMLCH048 from '@/components/xhtml/ch048'
 import XHTMLCH049 from '@/components/xhtml/ch049'
 import XHTMLCH050 from '@/components/xhtml/ch050'
 import XHTMLCH051 from '@/components/xhtml/ch051'
 import XHTMLCH052 from '@/components/xhtml/ch052'
 import XHTMLCH053 from '@/components/xhtml/ch053'
 import XHTMLCH054 from '@/components/xhtml/ch054'
 import XHTMLCH055 from '@/components/xhtml/ch055'
 import XHTMLCH056 from '@/components/xhtml/ch056'
 import XHTMLCH057 from '@/components/xhtml/ch057'
 import XHTMLCH058 from '@/components/xhtml/ch058'
 import XHTMLCH059 from '@/components/xhtml/ch059'
 import XHTMLCH060 from '@/components/xhtml/ch060'
 import XHTMLCH061 from '@/components/xhtml/ch061'
 import XHTMLCH062 from '@/components/xhtml/ch062'
 import XHTMLCH063 from '@/components/xhtml/ch063'
 import XHTMLCH064 from '@/components/xhtml/ch064'
 import XHTMLCH065 from '@/components/xhtml/ch065'
 import XHTMLCH066 from '@/components/xhtml/ch066'
 import XHTMLCH067 from '@/components/xhtml/ch067'
 import XHTMLCH068 from '@/components/xhtml/ch068'
 import XHTMLCH069 from '@/components/xhtml/ch069'
 import XHTMLCH070 from '@/components/xhtml/ch070'
 import XHTMLCH071 from '@/components/xhtml/ch071'
 import XHTMLCH072 from '@/components/xhtml/ch072'
 import XHTMLCH073 from '@/components/xhtml/ch073'
 import XHTMLCH074 from '@/components/xhtml/ch074'
 import XHTMLCH075 from '@/components/xhtml/ch075'
 import XHTMLCH076 from '@/components/xhtml/ch076'
 import XHTMLCH077 from '@/components/xhtml/ch077'
 import XHTMLCH078 from '@/components/xhtml/ch078'
 import XHTMLCH079 from '@/components/xhtml/ch079'
 import XHTMLCH080 from '@/components/xhtml/ch080'
 import XHTMLCH081 from '@/components/xhtml/ch081'
 import XHTMLCH082 from '@/components/xhtml/ch082'
 import XHTMLCH083 from '@/components/xhtml/ch083'
 import XHTMLCH084 from '@/components/xhtml/ch084'
 import XHTMLCH085 from '@/components/xhtml/ch085'
 import XHTMLCH086 from '@/components/xhtml/ch086'
 import XHTMLCH087 from '@/components/xhtml/ch087'
 import XHTMLCH088 from '@/components/xhtml/ch088'
 import XHTMLCH089 from '@/components/xhtml/ch089'
 import XHTMLCH090 from '@/components/xhtml/ch090'
 import XHTMLCH091 from '@/components/xhtml/ch091'
 import XHTMLCH092 from '@/components/xhtml/ch092'
 import XHTMLCH093 from '@/components/xhtml/ch093'
 import XHTMLCH094 from '@/components/xhtml/ch094'
 import XHTMLCH095 from '@/components/xhtml/ch095'
 import XHTMLCH096 from '@/components/xhtml/ch096'
 import XHTMLCH097 from '@/components/xhtml/ch097'
 import XHTMLCH098 from '@/components/xhtml/ch098'
 import XHTMLCH099 from '@/components/xhtml/ch099'
 import XHTMLCH100 from '@/components/xhtml/ch100'
 import XHTMLCH101 from '@/components/xhtml/ch101'
 import XHTMLCH102 from '@/components/xhtml/ch102'
 import XHTMLCH103 from '@/components/xhtml/ch103'
 import XHTMLCH104 from '@/components/xhtml/ch104'
 import XHTMLCH105 from '@/components/xhtml/ch105'
 import XHTMLCH106 from '@/components/xhtml/ch106'
 import XHTMLCH107 from '@/components/xhtml/ch107'
 import XHTMLCH108 from '@/components/xhtml/ch108'
 import XHTMLCH109 from '@/components/xhtml/ch109'
 import XHTMLCH110 from '@/components/xhtml/ch110'
 import XHTMLCH111 from '@/components/xhtml/ch111'
 import XHTMLCH112 from '@/components/xhtml/ch112'
 import XHTMLCH113 from '@/components/xhtml/ch113'
 import XHTMLCH114 from '@/components/xhtml/ch114'
 import XHTMLCH115 from '@/components/xhtml/ch115'
 import XHTMLCH116 from '@/components/xhtml/ch116'
 import XHTMLCH117 from '@/components/xhtml/ch117'
 import XHTMLCH118 from '@/components/xhtml/ch118'
 import XHTMLCH119 from '@/components/xhtml/ch119'
 import XHTMLCH120 from '@/components/xhtml/ch120'
 import XHTMLCH121 from '@/components/xhtml/ch121'
 import XHTMLCH122 from '@/components/xhtml/ch122'
 import XHTMLCH123 from '@/components/xhtml/ch123'
 import XHTMLCH124 from '@/components/xhtml/ch124'
 import XHTMLCH125 from '@/components/xhtml/ch125'
 import XHTMLCH126 from '@/components/xhtml/ch126'
 import XHTMLCH127 from '@/components/xhtml/ch127'
 import XHTMLCH128 from '@/components/xhtml/ch128'
 import XHTMLCH129 from '@/components/xhtml/ch129'
 import XHTMLCH130 from '@/components/xhtml/ch130'
 import XHTMLCH131 from '@/components/xhtml/ch131'
 import XHTMLCH132 from '@/components/xhtml/ch132'
 import XHTMLCH133 from '@/components/xhtml/ch133'
 import XHTMLCH134 from '@/components/xhtml/ch134'
 import XHTMLCH135 from '@/components/xhtml/ch135'
 import XHTMLCH136 from '@/components/xhtml/ch136'
 import XHTMLCH137 from '@/components/xhtml/ch137'
 import XHTMLCH138 from '@/components/xhtml/ch138'
 import XHTMLCH139 from '@/components/xhtml/ch139'
 import XHTMLCH140 from '@/components/xhtml/ch140'
 import XHTMLCH141 from '@/components/xhtml/ch141'
 import XHTMLCH142 from '@/components/xhtml/ch142'
 import XHTMLCH143 from '@/components/xhtml/ch143'
 import XHTMLCH144 from '@/components/xhtml/ch144'
 import XHTMLCH145 from '@/components/xhtml/ch145'
 import XHTMLCH146 from '@/components/xhtml/ch146'
 import XHTMLCH147 from '@/components/xhtml/ch147'
 import XHTMLCH148 from '@/components/xhtml/ch148'
 import XHTMLCH149 from '@/components/xhtml/ch149'
 import XHTMLCH150 from '@/components/xhtml/ch150'
 import XHTMLCH151 from '@/components/xhtml/ch151'
 import XHTMLCH152 from '@/components/xhtml/ch152'
 import XHTMLCH153 from '@/components/xhtml/ch153'
 import XHTMLCH154 from '@/components/xhtml/ch154'
 import XHTMLCH155 from '@/components/xhtml/ch155'
 import XHTMLCH156 from '@/components/xhtml/ch156'
 import XHTMLCH157 from '@/components/xhtml/ch157'
 import XHTMLCH158 from '@/components/xhtml/ch158'
 import XHTMLCH159 from '@/components/xhtml/ch159'
 import XHTMLCH160 from '@/components/xhtml/ch160'
 import XHTMLCH161 from '@/components/xhtml/ch161'
 import XHTMLCH162 from '@/components/xhtml/ch162'
 import XHTMLCH163 from '@/components/xhtml/ch163'
 import XHTMLCH164 from '@/components/xhtml/ch164'
 import XHTMLCH165 from '@/components/xhtml/ch165'
 import XHTMLCH166 from '@/components/xhtml/ch166'
 import XHTMLCH167 from '@/components/xhtml/ch167'
 import XHTMLCH168 from '@/components/xhtml/ch168'
 import XHTMLCH169 from '@/components/xhtml/ch169'
 import XHTMLCH170 from '@/components/xhtml/ch170'
 import XHTMLCH171 from '@/components/xhtml/ch171'
 import XHTMLCH172 from '@/components/xhtml/ch172'
 import XHTMLCH173 from '@/components/xhtml/ch173'
 import XHTMLCH174 from '@/components/xhtml/ch174'
 import XHTMLCH175 from '@/components/xhtml/ch175'
 import XHTMLCH176 from '@/components/xhtml/ch176'
 import XHTMLCH177 from '@/components/xhtml/ch177'
 import XHTMLCH178 from '@/components/xhtml/ch178'
 import XHTMLCH179 from '@/components/xhtml/ch179'
 import XHTMLCH180 from '@/components/xhtml/ch180'
 import XHTMLCH181 from '@/components/xhtml/ch181'
 import XHTMLCH182 from '@/components/xhtml/ch182'
 import XHTMLCH183 from '@/components/xhtml/ch183'
 import XHTMLCH184 from '@/components/xhtml/ch184'
 import XHTMLCH185 from '@/components/xhtml/ch185'
 import XHTMLCH186 from '@/components/xhtml/ch186'
 import XHTMLCH187 from '@/components/xhtml/ch187'
 import XHTMLCH188 from '@/components/xhtml/ch188'
 import XHTMLCH189 from '@/components/xhtml/ch189'
 import XHTMLCH190 from '@/components/xhtml/ch190'
 import XHTMLCH191 from '@/components/xhtml/ch191'
 import XHTMLCH192 from '@/components/xhtml/ch192'
 import XHTMLCH193 from '@/components/xhtml/ch193'
 import XHTMLCH194 from '@/components/xhtml/ch194'
 import XHTMLCH195 from '@/components/xhtml/ch195'
 import XHTMLCH196 from '@/components/xhtml/ch196'
 import XHTMLCH197 from '@/components/xhtml/ch197'
 import XHTMLCH198 from '@/components/xhtml/ch198'
 import XHTMLCH199 from '@/components/xhtml/ch199'
 import XHTMLCH200 from '@/components/xhtml/ch200'
 import XHTMLCH201 from '@/components/xhtml/ch201'
 import XHTMLCH202 from '@/components/xhtml/ch202'
 import XHTMLCH203 from '@/components/xhtml/ch203'
 import XHTMLCH204 from '@/components/xhtml/ch204'
 import XHTMLCH205 from '@/components/xhtml/ch205'
 import XHTMLCH206 from '@/components/xhtml/ch206'
 import XHTMLCH207 from '@/components/xhtml/ch207'
 import XHTMLCH208 from '@/components/xhtml/ch208'
 import XHTMLCH209 from '@/components/xhtml/ch209'
 import XHTMLCH210 from '@/components/xhtml/ch210'
 import XHTMLCH211 from '@/components/xhtml/ch211'
 import XHTMLCH212 from '@/components/xhtml/ch212'
 import XHTMLCH213 from '@/components/xhtml/ch213'
 import XHTMLCH214 from '@/components/xhtml/ch214'
 import XHTMLCH215 from '@/components/xhtml/ch215'
 import XHTMLCH216 from '@/components/xhtml/ch216'
 import XHTMLCH217 from '@/components/xhtml/ch217'
 import XHTMLCH218 from '@/components/xhtml/ch218'
 import XHTMLCH219 from '@/components/xhtml/ch219'
 import XHTMLCH220 from '@/components/xhtml/ch220'
 import XHTMLCH221 from '@/components/xhtml/ch221'
 import XHTMLCH222 from '@/components/xhtml/ch222'
 import XHTMLCH223 from '@/components/xhtml/ch223'
 import XHTMLCH224 from '@/components/xhtml/ch224'
 import XHTMLCH225 from '@/components/xhtml/ch225'
 import XHTMLCH226 from '@/components/xhtml/ch226'
 import XHTMLCH227 from '@/components/xhtml/ch227'
 import XHTMLCH228 from '@/components/xhtml/ch228'
 import XHTMLCH229 from '@/components/xhtml/ch229'
 import XHTMLCH230 from '@/components/xhtml/ch230'
 import XHTMLCH231 from '@/components/xhtml/ch231'
 import XHTMLCH232 from '@/components/xhtml/ch232'
 import XHTMLCH233 from '@/components/xhtml/ch233'
 import XHTMLCH234 from '@/components/xhtml/ch234'
 import XHTMLCH235 from '@/components/xhtml/ch235'
 import XHTMLCH236 from '@/components/xhtml/ch236'
 import XHTMLCH237 from '@/components/xhtml/ch237'
 import XHTMLCH238 from '@/components/xhtml/ch238'
 import XHTMLCH239 from '@/components/xhtml/ch239'
 import XHTMLCH240 from '@/components/xhtml/ch240'
 import XHTMLCH241 from '@/components/xhtml/ch241'
 import XHTMLCH242 from '@/components/xhtml/ch242'
 import XHTMLCH243 from '@/components/xhtml/ch243'
 import XHTMLCH244 from '@/components/xhtml/ch244'
 import XHTMLCH245 from '@/components/xhtml/ch245'
 import XHTMLCH246 from '@/components/xhtml/ch246'
 import XHTMLCH247 from '@/components/xhtml/ch247'
 import XHTMLCH248 from '@/components/xhtml/ch248'
 import XHTMLCH249 from '@/components/xhtml/ch249'
 import XHTMLCH250 from '@/components/xhtml/ch250'
 import XHTMLCH251 from '@/components/xhtml/ch251'
 import XHTMLCH252 from '@/components/xhtml/ch252'
 import XHTMLCH253 from '@/components/xhtml/ch253'
 import XHTMLCH254 from '@/components/xhtml/ch254'
 import XHTMLCH255 from '@/components/xhtml/ch255'
 import XHTMLCH256 from '@/components/xhtml/ch256'
 import XHTMLCH257 from '@/components/xhtml/ch257'
 import XHTMLCH258 from '@/components/xhtml/ch258'
 import XHTMLCH259 from '@/components/xhtml/ch259'
 import XHTMLCH260 from '@/components/xhtml/ch260'
 import XHTMLCH261 from '@/components/xhtml/ch261'
 import XHTMLCH262 from '@/components/xhtml/ch262'
 import XHTMLCH263 from '@/components/xhtml/ch263'
 import XHTMLCH264 from '@/components/xhtml/ch264'
 import XHTMLCH265 from '@/components/xhtml/ch265'
 import XHTMLCH266 from '@/components/xhtml/ch266'
 import XHTMLCH267 from '@/components/xhtml/ch267'
 import XHTMLCH268 from '@/components/xhtml/ch268'
 import XHTMLCH269 from '@/components/xhtml/ch269'
 import XHTMLCH270 from '@/components/xhtml/ch270'
 import XHTMLCH271 from '@/components/xhtml/ch271'
 import XHTMLCH272 from '@/components/xhtml/ch272'
 import XHTMLCH273 from '@/components/xhtml/ch273'
 import XHTMLCH274 from '@/components/xhtml/ch274'
 import XHTMLCH275 from '@/components/xhtml/ch275'
 import XHTMLCH276 from '@/components/xhtml/ch276'
 import XHTMLCH277 from '@/components/xhtml/ch277'
 import XHTMLCH278 from '@/components/xhtml/ch278'
 import XHTMLCH279 from '@/components/xhtml/ch279'
 import XHTMLCH280 from '@/components/xhtml/ch280'
 import XHTMLCH281 from '@/components/xhtml/ch281'
 import XHTMLCH282 from '@/components/xhtml/ch282'
 import XHTMLCH283 from '@/components/xhtml/ch283'
 import XHTMLCH284 from '@/components/xhtml/ch284'
 import XHTMLCH285 from '@/components/xhtml/ch285'
 import XHTMLCH286 from '@/components/xhtml/ch286'
 import XHTMLCH287 from '@/components/xhtml/ch287'
 import XHTMLCH288 from '@/components/xhtml/ch288'
 import XHTMLCH289 from '@/components/xhtml/ch289'
 import XHTMLCH290 from '@/components/xhtml/ch290'
 import XHTMLCH291 from '@/components/xhtml/ch291'
 import XHTMLCH292 from '@/components/xhtml/ch292'
 import XHTMLCH293 from '@/components/xhtml/ch293'
 import XHTMLCH294 from '@/components/xhtml/ch294'
 import XHTMLCH295 from '@/components/xhtml/ch295'
 import XHTMLCH296 from '@/components/xhtml/ch296'
 import XHTMLCH297 from '@/components/xhtml/ch297'
 import XHTMLCH298 from '@/components/xhtml/ch298'
 import XHTMLCH299 from '@/components/xhtml/ch299'
 import XHTMLCH300 from '@/components/xhtml/ch300'
 import XHTMLCH301 from '@/components/xhtml/ch301'
 import XHTMLCH302 from '@/components/xhtml/ch302'
 import XHTMLCH303 from '@/components/xhtml/ch303'
 import XHTMLCH304 from '@/components/xhtml/ch304'
 import XHTMLCH305 from '@/components/xhtml/ch305'
 import XHTMLCH306 from '@/components/xhtml/ch306'
 import XHTMLCH307 from '@/components/xhtml/ch307'
 import XHTMLCH308 from '@/components/xhtml/ch308'
 import XHTMLCH309 from '@/components/xhtml/ch309'
 import XHTMLCH310 from '@/components/xhtml/ch310'
 import XHTMLCH311 from '@/components/xhtml/ch311'
 import XHTMLCH312 from '@/components/xhtml/ch312'
 import XHTMLCH313 from '@/components/xhtml/ch313'
 import XHTMLCH314 from '@/components/xhtml/ch314'
 import XHTMLCH315 from '@/components/xhtml/ch315'
 import XHTMLCH316 from '@/components/xhtml/ch316'
 import XHTMLCH317 from '@/components/xhtml/ch317'
 import XHTMLCH318 from '@/components/xhtml/ch318'
 import XHTMLCH319 from '@/components/xhtml/ch319'
 import XHTMLCH320 from '@/components/xhtml/ch320'
 import XHTMLCH321 from '@/components/xhtml/ch321'
 import XHTMLCH322 from '@/components/xhtml/ch322'
 import XHTMLCH323 from '@/components/xhtml/ch323'
 import XHTMLCH324 from '@/components/xhtml/ch324'
 import XHTMLCH325 from '@/components/xhtml/ch325'
 import XHTMLCH326 from '@/components/xhtml/ch326'
 import XHTMLCH327 from '@/components/xhtml/ch327'
 import XHTMLCH328 from '@/components/xhtml/ch328'
 import XHTMLCH329 from '@/components/xhtml/ch329'
 import XHTMLCH330 from '@/components/xhtml/ch330'
 import XHTMLCH331 from '@/components/xhtml/ch331'
 import XHTMLCH332 from '@/components/xhtml/ch332'
 import XHTMLCH333 from '@/components/xhtml/ch333'
 import XHTMLCH334 from '@/components/xhtml/ch334'
 import XHTMLCH335 from '@/components/xhtml/ch335'
 import XHTMLCH336 from '@/components/xhtml/ch336'
 import XHTMLCH337 from '@/components/xhtml/ch337'
 import XHTMLCH338 from '@/components/xhtml/ch338'
 import XHTMLCH339 from '@/components/xhtml/ch339'
 import XHTMLCH340 from '@/components/xhtml/ch340'
 import XHTMLCH341 from '@/components/xhtml/ch341'
 import XHTMLCH342 from '@/components/xhtml/ch342'
 import XHTMLCH343 from '@/components/xhtml/ch343'
 import XHTMLCH344 from '@/components/xhtml/ch344'
 import XHTMLCH345 from '@/components/xhtml/ch345'
 import XHTMLCH346 from '@/components/xhtml/ch346'
 import XHTMLCH347 from '@/components/xhtml/ch347'
 import XHTMLCH348 from '@/components/xhtml/ch348'
 import XHTMLCH349 from '@/components/xhtml/ch349'
 import XHTMLCH350 from '@/components/xhtml/ch350'
 import XHTMLCH351 from '@/components/xhtml/ch351'
 import XHTMLCH352 from '@/components/xhtml/ch352'
 import XHTMLCH353 from '@/components/xhtml/ch353'
 import XHTMLCH354 from '@/components/xhtml/ch354'
 import XHTMLCH355 from '@/components/xhtml/ch355'
 import XHTMLCH356 from '@/components/xhtml/ch356'
 import XHTMLCH357 from '@/components/xhtml/ch357'
 import XHTMLCH358 from '@/components/xhtml/ch358'
 import XHTMLCH359 from '@/components/xhtml/ch359'
 import XHTMLCH360 from '@/components/xhtml/ch360'
 import XHTMLCH361 from '@/components/xhtml/ch361'
 import XHTMLCH362 from '@/components/xhtml/ch362'
 import XHTMLCH363 from '@/components/xhtml/ch363'
 import XHTMLCH364 from '@/components/xhtml/ch364'
 import XHTMLCH365 from '@/components/xhtml/ch365'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCH366_INDEX from '@/components/xhtml/ch366_index'
 import XHTMLCH367_ACK from '@/components/xhtml/ch367_ack'
 import XHTMLCH368_COPY from '@/components/xhtml/ch368_copy'
 import XHTMLCH369 from '@/components/xhtml/ch369'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/ch000_fm03_intro",
 			"name" : "xhtml/ch000_fm03_intro",
 			"component" : XHTMLCH000_FM03_INTRO
 		},
 		{
 			"path" : "/xhtml/ch000_fm04_pre",
 			"name" : "xhtml/ch000_fm04_pre",
 			"component" : XHTMLCH000_FM04_PRE
 		},
 		{
 			"path" : "/xhtml/ch001",
 			"name" : "xhtml/ch001",
 			"component" : XHTMLCH001
 		},
 		{
 			"path" : "/xhtml/ch002",
 			"name" : "xhtml/ch002",
 			"component" : XHTMLCH002
 		},
 		{
 			"path" : "/xhtml/ch003",
 			"name" : "xhtml/ch003",
 			"component" : XHTMLCH003
 		},
 		{
 			"path" : "/xhtml/ch004",
 			"name" : "xhtml/ch004",
 			"component" : XHTMLCH004
 		},
 		{
 			"path" : "/xhtml/ch005",
 			"name" : "xhtml/ch005",
 			"component" : XHTMLCH005
 		},
 		{
 			"path" : "/xhtml/ch006",
 			"name" : "xhtml/ch006",
 			"component" : XHTMLCH006
 		},
 		{
 			"path" : "/xhtml/ch007",
 			"name" : "xhtml/ch007",
 			"component" : XHTMLCH007
 		},
 		{
 			"path" : "/xhtml/ch008",
 			"name" : "xhtml/ch008",
 			"component" : XHTMLCH008
 		},
 		{
 			"path" : "/xhtml/ch009",
 			"name" : "xhtml/ch009",
 			"component" : XHTMLCH009
 		},
 		{
 			"path" : "/xhtml/ch010",
 			"name" : "xhtml/ch010",
 			"component" : XHTMLCH010
 		},
 		{
 			"path" : "/xhtml/ch011",
 			"name" : "xhtml/ch011",
 			"component" : XHTMLCH011
 		},
 		{
 			"path" : "/xhtml/ch012",
 			"name" : "xhtml/ch012",
 			"component" : XHTMLCH012
 		},
 		{
 			"path" : "/xhtml/ch013",
 			"name" : "xhtml/ch013",
 			"component" : XHTMLCH013
 		},
 		{
 			"path" : "/xhtml/ch014",
 			"name" : "xhtml/ch014",
 			"component" : XHTMLCH014
 		},
 		{
 			"path" : "/xhtml/ch015",
 			"name" : "xhtml/ch015",
 			"component" : XHTMLCH015
 		},
 		{
 			"path" : "/xhtml/ch016",
 			"name" : "xhtml/ch016",
 			"component" : XHTMLCH016
 		},
 		{
 			"path" : "/xhtml/ch017",
 			"name" : "xhtml/ch017",
 			"component" : XHTMLCH017
 		},
 		{
 			"path" : "/xhtml/ch018",
 			"name" : "xhtml/ch018",
 			"component" : XHTMLCH018
 		},
 		{
 			"path" : "/xhtml/ch019",
 			"name" : "xhtml/ch019",
 			"component" : XHTMLCH019
 		},
 		{
 			"path" : "/xhtml/ch020",
 			"name" : "xhtml/ch020",
 			"component" : XHTMLCH020
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js